<div class="container">
    <app-risk-flow-risk-assesment 
    [config]="{
      consumerId: 'GC',
      flow: 'CWP',
      clientType: 'CLIENT'
    }"
    (resultHandler)="resultHandler($event)"
    (errorHandler)="errorHandler($event)">
    </app-risk-flow-risk-assesment>
    <onb-mfe-secure-link></onb-mfe-secure-link>
</div>